import { AppId, Route, createPageRoute } from '@lumapps/router';

export const askAiAnalyticsRoute: Route = createPageRoute({
    slug: 'analytics/ask-ai',
    id: 'ask-ai-analytics',
    appId: AppId.backOffice,
});
